import { lazy } from "react"
import type { FC, LazyExoticComponent } from "react"

async function loader(): Promise<{ default: FC }> {
    return import("./participant.diagnostic-summary.page").then(
        ({ ParticipantDiagnosticSummaryPage: DP }): { default: FC } => ({
            default: DP
        })
    )
}

const ParticipantDiagnosticSummaryPage: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => loader())

export { ParticipantDiagnosticSummaryPage }

async function participantDiagnosticSummaryPagePreloader(): Promise<void> {
    await loader()
}

export { participantDiagnosticSummaryPagePreloader }
